import { createContext } from "react";

export const MissingProfileDataAlertContext = createContext({});
